import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiEndpoints } from '@core/constants/api-endpoints';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  constructor(private readonly api: ApiService) {}

  list(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.PAYMENT_LIST, payload);
  }

  yearlySummary(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.YEARLY_PAYMENT_SUMMARY, payload);
  }

  create(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.PAYMENT_CREATE, payload);
  }

  update(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.PAYMENT_UPDATE, payload);
  }

  delete(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.PAYMENT_DELETE, payload);
  }

  sendReceiptByEmail(payload: {
    paymentId: number;
    email: string;
    pdfBase64: string;
    fileName: string;
  }): Observable<any> {
    return this.api.postHandler(ApiEndpoints.RECEIPT_SEND_EMAIL, payload);
  }

  prepareReceiptWhatsapp(payload: {
    paymentId: number;
    whatsappNumber: string;
  }): Observable<any> {
    return this.api.postHandler(ApiEndpoints.RECEIPT_SEND_WHATSAPP, payload);
  }
}
